import { getOmniLogger } from 'omni-package-react-logging';

const logger = getOmniLogger('we-client-space');

export default logger;
